module.exports = __webpack_public_path__ + "static/media/thumb-tuvototuidioma.a70bca74.png";